module.exports = __webpack_public_path__ + "static/img/wavm8s-015-dj-animebby.1a3ffa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-015-dj-animebby.png
// module id = AWzD
// module chunks = 0